export enum FreelancerDeclineReason {
  NotAvailable = 1,
  NotInterested = 2,
  ClientNotInterested = 3,
  MissingSkills = 4,
  Other = 5
}
